import { isLocalhost } from "@/Configs/config";

export function getTenantUrl(companyCode?: string) {
  if (!companyCode) return "";

  let currentUrl = new URL(window.location.href);
  if (isLocalhost) {
    // Pretend we're running on the test environment even if we're on localhost
    currentUrl = new URL("https://insight.test-1.carrot.tech");
  }
  const subdomain = currentUrl.hostname.split(".")[0];
  return `${currentUrl.protocol}//${currentUrl.hostname.replace(subdomain, "tenants")}?login_code=${companyCode}`;
}
